import {faStar as faStarOutline} from '@fortawesome/pro-regular-svg-icons';
import {faStar as faStarSolid} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useAddToFavoritesModal} from '@rdcomponents/navigation/favorite-routes/add-to-favorites-modal';
import {useRemoveFromFavoritesModal} from '@rdcomponents/navigation/favorite-routes/remove-from-favorites-modal';
import {Tooltip} from 'antd';
import {ReactNode, useCallback, useMemo} from 'react';

import {Locale} from '../../../provider/locale/localization';
import {useUser} from '../../../provider/user/user-hook';

import * as styles from './menu-item-with-favorite.scss';

type PropsType = {
    label: ReactNode;
    path: string;
    childPaths: Array<string>;
};

export function MenuItemWithFavoriteStar(props: PropsType): JSX.Element {
    const {label, path, childPaths} = props;

    const handleAddFavorite = useAddToFavoritesModal();
    const handleRemoveFavorite = useRemoveFromFavoritesModal();
    const {favorites} = useUser();

    const isInFavouriteSection = useMemo(() => favorites?.includes(path), [favorites, path]);

    const handleStarClick = useCallback(
        (event: React.KeyboardEvent | React.MouseEvent) => {
            event.preventDefault();
            event.stopPropagation();

            if (isInFavouriteSection) {
                handleRemoveFavorite(path, childPaths);
            } else {
                handleAddFavorite(path, childPaths);
            }
        },
        [isInFavouriteSection, handleRemoveFavorite, path, childPaths, handleAddFavorite]
    );

    return (
        <div className={styles.MenuItemWithFavorite}>
            <span className={styles.MenuItemWithFavorite__label}>{label}</span>
            <Tooltip
                placement="right"
                title={
                    <Locale
                        stringKey={
                            isInFavouriteSection
                                ? 'NAVIGATION__REMOVE_FROM_FAVORITES__TITLE'
                                : 'NAVIGATION__ADD_TO_FAVORITES__TITLE'
                        }
                    />
                }
            >
                <span
                    className={styles.MenuItemWithFavorite__star}
                    onClickCapture={handleStarClick}
                    role="button"
                    tabIndex={0}
                >
                    <FontAwesomeIcon icon={isInFavouriteSection ? faStarSolid : faStarOutline} />
                </span>
            </Tooltip>
        </div>
    );
}
